import { IV1ComponentDataGuestCalendarResponse } from 'shared/repositories/dailyrent/entities/response/V1ComponentDataGuestCalendarResponse';
import { fetchComponentDataGuestCalendar } from 'shared/repositories/dailyrent/v1/component-data/guest-calendar/apiHelpers';
import {
  IComponentDataGuestCalendarRequest,
  type TComponentDataGuestCalendarResponse,
} from 'shared/repositories/dailyrent/v1/component-data/guest-calendar/types';
import { IApplicationContext } from 'shared/types/applicationContext';
import { ICalendarDayData } from 'shared/types/bookingCalendar';

export const DEFAULT_ERROR_MESSAGE = 'Произошла ошибка при проверке доступности';

interface IMappedResponse {
  statusCode: 200;
  response: { calendar: ICalendarDayData[] };
}

interface IMappedError {
  statusCode: 400;
}

export const fetchGuestCalendar = async (
  context: IApplicationContext,
  parameters: IComponentDataGuestCalendarRequest,
): Promise<ICalendarDayData[]> => {
  const { httpApi } = context;

  const mappers = {
    200: (response: IV1ComponentDataGuestCalendarResponse): IMappedResponse => ({
      statusCode: 200,
      response: {
        calendar: response.calendar.map(day => ({
          date: day.date,
          status: day.status as ICalendarDayData['status'],
          priceLabel: day.price ?? undefined,
        })),
      },
    }),
    400: (): IMappedError => ({ statusCode: 400 }),
  };

  const { statusCode, response } = (await fetchComponentDataGuestCalendar({
    httpApi,
    parameters,
    mappers,
  })) as TComponentDataGuestCalendarResponse;

  if (statusCode === 400) {
    throw new Error(DEFAULT_ERROR_MESSAGE);
  }

  return response.calendar;
};
